import { createFileRoute } from '@tanstack/react-router';
import { DocPage } from '@/components/docs/DocPage';
import { templatesDocTitle, templatesDocDescription, templatesDocSections } from '@/content/docs/templates';

export const Route = createFileRoute('/_admin/docs/templates')({
  component: DocsTemplatesPage,
});

function DocsTemplatesPage() {
  return (
    <DocPage
      title={templatesDocTitle}
      description={templatesDocDescription}
      sections={templatesDocSections}
    />
  );
}
